import { Card } from "@/components/ui/atoms/Card";

export function TypingIndicator() {
  return (
    <Card
      variant="custom"
      padding="none"
      rounded="xl"
      className="!m-0 inline-flex items-center justify-center gap-1 border border-dark-invirtus-soft bg-light px-3.5 py-3 shadow-none"
    >
      <span
        className="h-2 w-2 rounded-full bg-grey-muted animate-bounce"
        style={{ animationDelay: "0ms" }}
      />
      <span
        className="h-2 w-2 rounded-full bg-grey-muted animate-bounce"
        style={{ animationDelay: "150ms" }}
      />
      <span
        className="h-2 w-2 rounded-full bg-grey-muted animate-bounce"
        style={{ animationDelay: "300ms" }}
      />
    </Card>
  );
}
